import { Routes } from '@angular/router';
import { LandingPage } from './landing-page/pages/landing/landing.page';
import { ShellLayout } from './layouts/shell/shell.layout';
import { emailVerifiedGuard } from './auth/guards/email-verified.guard';
import { initialRedirectGuard } from './auth/guards/initial-redirect.guard';
import { oauthAuthorizeGuard, oauthReturnGuard } from './auth/guards/oauth-return';


export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [initialRedirectGuard],
    component: LandingPage // Use a lightweight component as a placeholder, though the guard will always redirect
  },
  {
    path: 'welcome',
    component: LandingPage
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth.routes').then((m) => m.AUTH_ROUTES)
  },
  {
    // Stripe Checkout redirect targets (top-level, outside the app shell).
    path: 'subscription/success',
    loadComponent: () =>
      import('./subscription/pages/success/success.page').then(
        (m) => m.SubscriptionSuccessPage
      )
  },
  {
    path: 'subscription/cancel',
    loadComponent: () =>
      import('./subscription/pages/cancel/cancel.page').then(
        (m) => m.SubscriptionCancelPage
      )
  },
  {
    // A partner (ClearTax) sends the user here to approve a connection; outside the app shell.
    path: 'oauth/authorize',
    canActivate: [oauthAuthorizeGuard],
    loadComponent: () =>
      import('./oauth/authorize/oauth-authorize.page').then(
        (m) => m.OAuthAuthorizePage
      )
  },
  {
    path: 'app',
    component: ShellLayout,
    canActivate: [emailVerifiedGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [oauthReturnGuard],
        loadComponent: () =>
          import('./dashboard/pages/dashboard/dashboard.page').then(
            (m) => m.DashboardPage
          )
      },
      {
        path: 'portfolio',
        loadComponent: () =>
          import('./portfolio/portfolio.page').then(
            (m) => m.PortfolioPage
          )
      },
      {
        path: 'ai-optimizer',
        loadComponent: () =>
          import('./ai-optimizer/ai-optimizer.page').then(
            (m) => m.AIOptimizerPage
          )
      },
      {
        path: 'harvestable-losses',
        loadComponent: () =>
          import('./harvestable-losses/pages/harvestable-losses/harvestable-losses.page').then(
            (m) => m.HarvestableLossesPage
          )
      },
      {
        path: 'transactions',
        loadChildren: () =>
          import('./transactions/transactions.routes').then(
            (m) => m.TRANSACTIONS_ROUTES
          )
      },
      {
        path: 'tax-center',
        loadComponent: () =>
          import('./tax-center/tax-center.page').then(
            (m) => m.TaxCenterPage
          )
      },
      {
        path: 'zk-proofs',
        loadComponent: () =>
          import('./zk-proofs/zk-proofs.page').then(
            (m) => m.ZKProofsPage
          )
      },
      {
        path: 'rwa-assets',
        loadComponent: () =>
          import('./rwa-assets/rwa-assets.page').then(
            (m) => m.RWAAssetsPage
          )
      },
      {
        path: 'integrations',
        loadChildren: () =>
          import('./integrations/integrations.routes').then(
            (m) => m.INTEGRATIONS_ROUTES
          )
      },
      {
        path: 'residency',
        loadComponent: () =>
          import('./residency/residency.page').then(
            (m) => m.ResidencyPage
          )
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./settings/settings.page').then(
            (m) => m.SettingsPage
          )
      },
      {
        path: 'accountant-access',
        loadComponent: () =>
          import('./accountant-access/accountant-access.page').then(
            (m) => m.AccountantAccessPage
          )
      },
      {
        path: 'pricing',
        loadComponent: () =>
          import('./subscription/pages/pricing/pricing.page').then(
            (m) => m.PricingPage
          )
      },
      {
        path: 'api-management',
        loadComponent: () =>
          import('./api-management/pages/api-management/api-management.page').then(
            (m) => m.ApiManagementPage
          )
      },
      {
        path: 'support',
        loadChildren: () =>
          import('./support/support.routes').then((m) => m.SUPPORT_ROUTES)
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
